export const BankRecordType = {
	INCOME: 'INCOME',
	EXPENSE: 'EXPENSE'
};

export const BankRecordProcessedStatusType = {
	PROCESSED: true,
	NOT_PROCESSED: false
};
